export class OpenerSlate {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "OpenerSlate";
    this.scene = "OpenerSlate";
    this.data = [];
    this.page = 620;
  }

  async preview({ options }) {
    this.onAir = false;

    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    xml.payload.field.find((item) => {
      return item.attr.name === "01012"; // Number
    }).value = options.game?.home_team?.variables?.badge || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "01022"; // Number
    }).value = options.game?.away_team?.variables?.badge || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "01011"; // Number
    }).value = options?.game?.home_team?.short_name?.toUpperCase();

    xml.payload.field.find((item) => {
      return item.attr.name === "01021"; // Number
    }).value = options?.game?.away_team?.short_name?.toUpperCase();

    await this.updateVizPage({ page: this.page, data: xml, escape: false });
    this.sendPreview("page:read " + this.page);
    this.comms(options);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.sendAnimateOff({ page: this.page });
    this.onAir = false;
  }
}
